import { Progress } from "@/components/ui/progress";

export function IntakeStepHeader({ section, currentIndex, totalSections, progressPct }) {
  return (
    <header className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <span className="letter-mark h-12 w-12 text-xl shadow-paper">{section.letter}</span>
          <div>
            <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              Section {section.code} of 0{totalSections} · {section.letter}
            </p>
            <h1 className="font-display text-2xl font-medium leading-tight text-foreground sm:text-3xl">
              {section.title}
            </h1>
          </div>
        </div>
        <div className="min-w-[140px] font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {Math.round(progressPct)}% complete
        </div>
      </div>
      <p className="max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
        {section.subtitle}
      </p>
      <Progress value={progressPct} className="h-1 rounded-none bg-secondary [&>div]:bg-primary" />
    </header>
  );
}
